import { TransactionTypePipe } from './transaction-type.pipe';
import { EnvironmentPipe } from './environment.pipe';
import { NumberFormatPipe } from './number-format.pipe';

export const pipes: any[] = [
  TransactionTypePipe,
  EnvironmentPipe,
  NumberFormatPipe,
];
